var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.666748C4.39166 0.666748 0.666664 4.39175 0.666664 9.00008C0.666664 13.6084 4.39166 17.3334 9 17.3334C13.6083 17.3334 17.3333 13.6084 17.3333 9.00008C17.3333 4.39175 13.6083 0.666748 9 0.666748ZM13.1667 11.9917L11.9917 13.1667L9 10.1751L6.00833 13.1667L4.83333 11.9917L7.825 9.00008L4.83333 6.00841L6.00833 4.83342L9 7.82508L11.9917 4.83342L13.1667 6.00841L10.175 9.00008L13.1667 11.9917Z",
    fill: "center"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.666748C4.39166 0.666748 0.666664 4.39175 0.666664 9.00008C0.666664 13.6084 4.39166 17.3334 9 17.3334C13.6083 17.3334 17.3333 13.6084 17.3333 9.00008C17.3333 4.39175 13.6083 0.666748 9 0.666748ZM13.1667 11.9917L11.9917 13.1667L9 10.1751L6.00833 13.1667L4.83333 11.9917L7.825 9.00008L4.83333 6.00841L6.00833 4.83342L9 7.82508L11.9917 4.83342L13.1667 6.00841L10.175 9.00008L13.1667 11.9917Z",
    fill: "center"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRounded);
export default __webpack_public_path__ + "static/media/CrossRounded.76e85f02215383ab617815f0219e30bc.svg";
export { ForwardRef as ReactComponent };